import {ModuleList} from "./ModuleList";
import {ModuleEdit} from "./ModuleEdit";
import {ModuleCreate} from "./ModuleCreate";

export default {
    list: ModuleList,
    create: ModuleCreate,
    edit: ModuleEdit
};
